import { ThemeComponent } from '@/theme/ThemeComponent';
import {Component, Prop, Ref } from '@eastsideco/salvo-ts';
import type { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { cart } from '@/theme/Cart';

import './CartMain.scss';

@Component
export class CartMain extends ThemeComponent {
    @Prop({ default: 'cart-main' }) sectionId!: string;
    @Prop({ default: false }) isAbsoluter!: boolean;

    @Ref() updatingCart!: LoadingSpinner;
    private cartState: string = '';

    async init() {
        cart.onLoad(() => {
            this.cartState = this.createCartState();

            // Listen for cart changes
            this.$subscribe(cart.onTransactedChange, async () => {
                // Re-render cart on change
                await this.renderCart();
            });
        });
    }

    private renderAttemptIndex = 0;

    createCartState() {
        return JSON.stringify(cart.items.map((item) => ({
            ...item,
            title: undefined, // sometimes HTML encoded contents, so ignore it
            cart: undefined,
        })));
    }

    private async renderCart() {

        // Compare new cart state with previous state
        const newCartState = this.createCartState();

        //  If there's no cart state change, return
        if (this.cartState == newCartState) {
            this.$log.info('Cart state matched. Bypassing cart update.');
            return;
        }

        // Save cart state
        this.cartState = newCartState;

        // Increment the render attempt index
        this.renderAttemptIndex++;

        // Handle item changes
        await this.updateItemsMarkup(this.renderAttemptIndex);
    }

    public setLoading(loading: boolean = false) {
        // Set loading state
        if (loading) {
            this.updatingCart.classList.add('is-active');
        } else {
            this.updatingCart.classList.remove('is-active');
        }
    }

    public async updateItemsMarkup(renderAttempt: number) {

        // If there is a new render attempt coming, exit
        if (renderAttempt < this.renderAttemptIndex) {
            return;
        }

        // Set cart main loading
        this.setLoading(true);

        const url = new URL(window.location.href)
        url.searchParams.set('sections', this.sectionId);
        const res = await fetch(url).then(response => response.json())

        // Prepare correct markup
        const newCartMain = document.createElement('div');
        newCartMain.innerHTML = res[this.sectionId];
        const newCartMainContainer = newCartMain.querySelector('.cart-main__container');
        const currentCartMainContainer = this.querySelector('.cart-main__container');
        if (newCartMainContainer && currentCartMainContainer) {
            currentCartMainContainer.outerHTML = newCartMainContainer.outerHTML;
        }

        // Set cart main loading
        this.setLoading(false);
    }
}